import { Button, Card, Icon, Pill, Stack, Text } from '@/design-system'
import { BentoGrid, BentoSpan } from '@/components/Bento'
import { StatTile } from '@/components/StatTile'
import { PageHeader } from '@/app/layouts/PageHeader'
import checkout from '@/app/layouts/CheckoutLayout.module.css'

const REASONS = [
  { icon: 'shield', title: 'It holds its value', body: 'When your local currency slips, the dollars you hold do not.' },
  { icon: 'bolt', title: 'Spend it straight away', body: 'The card draws on your USD balance with no extra conversion.' },
  { icon: 'send', title: 'Send it home cheaper', body: 'Sending from a USD balance skips one conversion entirely.' },
]

export function BuyUsdScreen() {
  return (
    <>
      <PageHeader
        title="Buy USD"
        subtitle="Hold dollars without a US bank account. One spread, no conversion fee on top."
        actions={<Button variant="primary" size="md" iconStart="add" to="/convert">Convert now</Button>}
      />

      <BentoGrid>
        {[
          { label: 'Rate today', value: '17.26 MXN', note: 'Mid-market minus 0.6%' },
          { label: 'Your USD balance', value: '$18,240.50', note: 'Available now' },
          { label: 'Spread', value: '0.6%', note: 'Shown in the rate' },
          { label: 'Conversion fee', value: 'None', tone: 'positive' as const, note: 'Nothing on top' },
        ].map((stat) => (
          <StatTile key={stat.label} stat={stat} />
        ))}

        <BentoSpan span={2}>
          <Card tone="light">
            <Text variant="caption" weight="semibold">Why people hold dollars here</Text>
            <div className={`${checkout.reasons} pb-mt-2`}>
              {REASONS.map((reason) => (
                <div key={reason.title} className={checkout.reason}>
                  <Icon name={reason.icon} size={20} />
                  <Stack gap={1}>
                    <Text variant="caption" weight="semibold">{reason.title}</Text>
                    <Text variant="caption" tone="secondary">{reason.body}</Text>
                  </Stack>
                </div>
              ))}
            </div>
          </Card>
        </BentoSpan>

        <BentoSpan span={2}>
          <Card tone="dark">
            <Card.Header>
              <Text variant="caption" weight="semibold" tone="onDark">Set it and forget it</Text>
              <Pill tone="accent">Auto-convert</Pill>
            </Card.Header>
            <Text variant="caption" tone="onDarkMuted" className="pb-mt-3">
              Move a fixed amount into dollars every month, on the day your salary lands. You can
              stop it at any time and nothing is charged to set it up.
            </Text>
            <Stack gap={0} className="pb-mt-4">
              {[['Every month on the 15th', '$300.00'], ['Spread', '0.6%'], ['Setup fee', 'None']].map(([label, value]) => (
                <div key={label} className={checkout.line}>
                  <Text variant="caption" tone="onDarkMuted">{label}</Text>
                  <Text variant="caption" weight="semibold" tone="onDark" numeric>{value}</Text>
                </div>
              ))}
            </Stack>
            <Card.Footer>
              <Button size="md" block iconEnd="arrow_forward" to="/convert/done">Set up auto-convert</Button>
            </Card.Footer>
          </Card>
        </BentoSpan>
      </BentoGrid>
    </>
  )
}
